import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import './typography.css'

const H5 = ({ children, className }) => <h5 className={cn('H5', className)}>{children}</h5>

H5.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default H5
